/* ============================================================
   Pholoh page tabs — pill toggle that reveals one target section at a time.
   Each tab button has data-tab-target="<section key>"; the matching section
   is the one whose id ends with "__<key>". Shows the active, hides the rest,
   with a soft fade-in.
   ============================================================ */
(function () {
  'use strict';
  var tabs = document.querySelector('[data-pholoh-tabs]');
  if (!tabs) return;

  var btns = Array.prototype.slice.call(tabs.querySelectorAll('.pholoh-tabs__btn'));
  if (!btns.length) return;

  function panel(target) {
    return target ? document.querySelector('[id$="__' + target + '"]') : null;
  }
  var targets = btns.map(function (b) { return b.getAttribute('data-tab-target'); });

  function show(active) {
    targets.forEach(function (t) {
      var p = panel(t);
      if (!p) return;
      if (t === active) {
        p.style.display = '';
        p.classList.remove('pholoh-tab-in');
        void p.offsetWidth;            // restart the fade
        p.classList.add('pholoh-tab-in');
      } else {
        p.style.display = 'none';
      }
    });
    btns.forEach(function (b) {
      b.classList.toggle('is-active', b.getAttribute('data-tab-target') === active);
    });
  }

  btns.forEach(function (b) {
    b.addEventListener('click', function () { show(b.getAttribute('data-tab-target')); });
  });

  show(targets[0]); // default: first tab
})();
